package com.exura.features.legacyplans.domain.model

import com.exura.features.firebase.domain.model.SerializableDomainModel
import dev.gitlive.firebase.firestore.CollectionReference

data class DetailedPlan(
    override val firebaseDocId: String? = null,
    override val firebaseDocPrefix: CollectionReference? = null,
    val id: String,
    val title: String,
    val shortDescription: String,
    val tasks: List<TimelyTask>,
    val checkups: List<TimelyCheckup>,
    val restrictions: List<TimelyRestriction>,
    val status: String = "pending", // TODO: just temp because of mimicing old BE
) : SerializableDomainModel
